import React from 'react'
import { useIntl } from 'react-intl'
import styles from './styles.module.css'

import IconFire from 'client/icons/Fire'

const Allotment = ({ allotment }: { allotment: number }) => {
  const intl = useIntl()
  return allotment > 0 && allotment < 8 ? (
    <div className={styles.allotmentContainer}>
      {allotment === 1 ? (
        <>
          <IconFire size={12} />
          <p>{intl.formatMessage({ id: 'allotment.last-room' })}</p>
        </>
      ) : (
        <>
          <IconFire size={12} />
          <p>{intl.formatMessage({ id: 'allotment.only-rooms' }, { roomsLeft: allotment })}</p>
        </>
      )}
    </div>
  ) : null
}

export default Allotment
